/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import _ from 'underscore';
import { toLegacy, toLegacyString } from './enum';

const EnumPropertyToTypeMapping = {
  AudienceStatus: ['AdGroupCriterionStatus'],
  BidTarget: ['BidTargetType'],
  BidType: ['BidType'],
  CampaignType: ['CampaignType'],
  CallTrackingStatus: ['AdGroupCallTrackingStatus'],
  DeliveryStatus: ['DeliveryStatus'],
  DevicePreference: ['DevicePreference'],
  DisplayBiddingStrategyType: ['BiddingStrategyType'],
  Language: ['Language'],
  Medium: ['Medium'],
  Status: ['CampaignStatus', 'AdGroupStatus', 'AudienceStatus', 'AdStatus'],
  Type: ['AdType'],
};
const EnumPropertyToStringTypeMapping = [
  'AudienceType',
  'Day',
];
const NoEnumPropertyToStringTypeMapping = [
  'DeviceName',
  'LevelOfDetails',
  'EditorialStatus',
  'AdGroupCashbackScope',
  'CampaignCashbackScope',
];
const BooleanToStringTypeMapping = [
  'IsAppealPending',
];

function toLegacyEnum(value, property) {
  if (_.contains(EnumPropertyToStringTypeMapping, property)) {
    const legacyValue = toLegacyString(value);

    if (legacyValue) {
      return legacyValue;
    }
  }

  if (_.contains(NoEnumPropertyToStringTypeMapping, property)) {
    return value;
  }

  const types = EnumPropertyToTypeMapping[property] || [property];

  if (_.size(types) > 0) {
    const legacyValue = toLegacy(value);

    if (legacyValue) {
      return legacyValue;
    }
  }

  return null;
}

function toLegacyOperator(op, col, schema) {
  let ret = op || '$eq';

  switch (ret) {
    case '$contains':
      ret = 'Contains';
      break;
    case '$doesnotcontain':
      ret = 'DoesNotContain';
      break;
    case '$startswith':
      ret = 'BeginsWith';
      break;
    case '$endswith':
      ret = 'EndsWith';
      break;
    case '$eq':
      ret = 'Equal';
      break;
    case '$neq':
      ret = 'NotEqual';
      break;
    case '$gt':
      ret = 'Greater';
      break;
    case '$gte':
      ret = 'GreaterOrEqual';
      break;
    case '$lt':
      ret = 'Less';
      break;
    case '$lte':
      ret = 'LessOrEqual';
      break;
    case '$in':
      if (schema.properties[col] && _.isEmpty(schema.properties[col].enum) && _.isEmpty(schema.properties[col].groupedItems)) {
        ret = 'Equal';
      } else {
        ret = 'EnumSelection';
      }
      break;
    case '$containsall':
      ret = 'ContainsAll';
      break;
    case '$containsany':
      ret = 'ContainsAny';
      break;
    case '$containsnone':
      ret = 'ContainsNone';
      break;
    default:
      break;
  }

  return ret;
}

function toLegacyColumn(col, filterSchema) {
  return filterSchema ? filterSchema.toAlias(col, 'legacy') : col;
}

function toLegacyValue(values, col, schema) {
  if (_.contains(BooleanToStringTypeMapping, col)) {
    return _.map(values, value => (value === true ? 'true' : 'false'));
  }

  if (schema.properties[col]) {
    if (!_.isEmpty(schema.properties[col].enum) || !_.isEmpty(schema.properties[col].groupedItems)) {
      return _.map(values, value => toLegacyEnum(value, col));
    } else if (schema.properties[col].type === 'boolean') {
      return _.map(values, value => (value === true ? 1 : 0));
    }
  }

  return values;
}

export function toLegacyFilter(filter) {
  const translateToLegacyFormat = function (query) {
    const condition = _.pairs(query)[0][1];
    const operator = _.pairs(condition)[0][0];
    let value = _.pairs(condition)[0][1];

    if (!_.isArray(value)) {
      value = [value];
    }

    return {
      SelectedColumn: _.pairs(query)[0][0],
      SelectedOperator: operator,
      Values: value,
    };
  };

  let schema;
  let legacyFormats;


  if (filter && filter.query && !_.isEmpty(filter.query)) {
    schema = filter.schema && filter.schema.entitySchema ?
      filter.schema.entitySchema :
      filter.options.entitySchema;

    if (filter.query.$and && filter.query.$and.length > 0) {
      legacyFormats = [];

      _.each(filter.query.$and, (query) => {
        if (query.$and) {
          legacyFormats = legacyFormats.concat(_.map(query.$and, subQuery => translateToLegacyFormat(subQuery)));
        } else {
          legacyFormats.push(translateToLegacyFormat(query));
        }
      });
    } else {
      legacyFormats = [translateToLegacyFormat(filter.query)];
    }
  }

  if (!_.isArray(legacyFormats)) {
    return null;
  }

  return _.map(legacyFormats, (legacyFormat) => {
    let col = legacyFormat.SelectedColumn;

    // replace Campaign/Status format to CampaignStatus type
    if (col.indexOf('/') !== -1) {
      col = col.split('/').join('');
    }

    // translate CamapaignIsExperiment to MT filter expression
    if (col === 'CampaignIsExperiment') {
      col = 'Campaign/ExperimentId';
      legacyFormat.SelectedOperator = legacyFormat.Values[0] ? '$gt' : '$le';
      legacyFormat.Values = [0];
    } else if (col === 'BidAmountBidAmount') {
      col = 'BidAmount/Bid/Amount';
    } else if (col === 'BidBoostMultiplier') {
      col = 'BidBoost/Multiplier';
    }

    return {
      SelectedColumn: toLegacyColumn(col, filter.schema),
      SelectedOperator: toLegacyOperator(legacyFormat.SelectedOperator, col, schema),
      Values: toLegacyValue(legacyFormat.Values, col, schema),
    };
  });
}
